import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import { getToken, getMe } from "context/AuthContext";
import { getPermissions } from "context/AuthContext";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "components/protectedRoute";

const Admin = (props) => {
  const [token, setToken] = useState(false);
  const mainContent = React.useRef(null);

  const me = getMe();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();

    if (!token || !me) {
      navigate("/auth/login", { replace: true });
      return;
    }

    if (
      window.location.pathname === "/admin" ||
      window.location.pathname === "/admin/"
    ) {
      navigate("/admin/dashboard", { replace: true });
      return;
    }

    if (me.partner !== "DEFAULT") {
      const allowedPaths = ["/admin/dashboard", "/admin/survey"];

      if (!allowedPaths.some((p) => window.location.pathname.startsWith(p))) {
        navigate("/admin/dashboard", { replace: true });
        return;
      }
    }

    setToken(true);
  }, [navigate, me]);

  const getRoutes = (routes) => {
    const permissions = getPermissions();
    return routes.flatMap((prop, key) => {
      if (prop.layout !== "/admin") return [];

      if (prop.permission && !permissions.includes(prop.permission)) {
        return [];
      }

      if (
        me?.partner !== "DEFAULT" &&
        !["/survey", "/dashboard"].includes(prop.path)
      ) {
        return [];
      }
      const routePath = prop.path.replace(/^\//, "");

      // collect normal route
      const mainRoute = (
        <Route
          path={routePath}
          element={
            <ProtectedRoute permission={prop.permission}>
              {prop.component}
            </ProtectedRoute>
          }
          key={key}
        />
      );

      const children =
        prop.subRoutes?.map((sub, subKey) => (
          <Route
            path={`${routePath}/${sub.path.replace(/^\//, "")}`}
            element={
              <ProtectedRoute permission={prop.permission}>
                {sub.component}
              </ProtectedRoute>
            }
            key={`${key}-${subKey}`}
          />
        )) || [];

      return [mainRoute, ...children];
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      {token ? (
        <>
          <Sidebar {...props} routes={routes} />
          <div className="main-content" ref={mainContent}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
              }}
            >
              <div style={{ flex: 1 }}>
                <ToastContainer />
                <AdminNavbar
                  {...props}
                  brandText={getBrandText(props?.location?.pathname)}
                />
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/admin/*"
                    element={<Navigate to="/admin/dashboard" replace />}
                  />
                </Routes>
              </div>
              <AdminFooter />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Admin;
